import React, { useState } from "react";
import { Button, Message, Confirm, Icon } from "semantic-ui-react";
import { useDispatch } from "react-redux";
import { updateInvitation, getInvitationList } from "../../redux/actions/invitation";

const InvitationMessage = ({ invitation }) => {
  const dispatch = useDispatch();
  const [confirming, setConfirming] = useState(false);
  const [loading, setLoading] = useState(false);
  const [accepted, setAccepted] = useState(false);
  const [declined, setDeclined] = useState(false);

  if (!invitation) return null;

  const handleAccept = async () => {
    setLoading(true);
    try {
      await dispatch(updateInvitation(invitation._id, { status: "accepted" }));
      await dispatch(getInvitationList());
      setAccepted(true);
    } catch (error) {
      console.error("Failed to accept invitation:", error);
    } finally {
      setLoading(false);
      setConfirming(false);
    }
  };

  const handleDecline = async () => {
    setLoading(true);
    try {
      await dispatch(updateInvitation(invitation._id, { status: "declined" }));
      await dispatch(getInvitationList());
      setDeclined(true);
    } catch (error) {
      console.error("Failed to decline invitation:", error);
    } finally {
      setLoading(false);
    }
  };

  if (accepted) {
    return (
      <Message 
        success
        icon
        style={{ 
          marginTop: "1em",
          marginBottom: "1em"
        }}
      >
        <Icon name="check circle" />
        <Message.Content>
          <Message.Header>Invitation Accepted!</Message.Header>
          <p>You've successfully joined the account.</p>
        </Message.Content>
      </Message>
    );
  }

  if (declined) {
    return (
      <Message 
        info
        style={{ marginTop: "1em", marginBottom: "1em" }}
      >
        Invitation declined.
      </Message>
    );
  }

  return (
    <Message
      info
      icon
      style={{ 
        marginTop: "1em",
        marginBottom: "1em"
      }}
    >
      <Icon name="envelope open outline" />
      <Message.Content>
        <Message.Header>Account Invitation</Message.Header>
        <p style={{ marginTop: "0.5em", marginBottom: "1em" }}>
          <strong>{invitation.created_by?.name || "Someone"}</strong> has invited you to join their account and collaborate on art collections.
        </p>
        <Button.Group size="small">
          <Button
            positive
            loading={loading}
            onClick={() => setConfirming(true)}
          >
            <Icon name="check" /> Accept
          </Button>
          <Button.Or />
          <Button
            onClick={handleDecline}
            disabled={loading}
          >
            Decline
          </Button>
        </Button.Group>
        <Confirm
          open={confirming}
          onCancel={() => setConfirming(false)}
          onConfirm={handleAccept}
          header="Accept Invitation"
          content={`Are you sure you want to accept the invitation from ${invitation.created_by?.name || "this user"}?`}
          confirmButton="Yes, Accept"
          cancelButton="Cancel"
        />
      </Message.Content>
    </Message>
  );
};

export default InvitationMessage;